module.exports = __webpack_public_path__ + "img/EX3_recog_neutral.acfb7bbd.jpg";